export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref5217.a8a40d1e.jpg";